import React from "react"
import PropTypes from "prop-types"
import { Button } from "@tencent/spaui"
import { Link } from "react-router-dom"
import { appendSearch } from "@/utils/ParamUtils"

class LinkButton extends React.PureComponent {
  static propTypes = {
    to: PropTypes.object,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }

  render() {
    const { onClick, disabled, ...props } = this.props
    let { to } = this.props

    if (onClick) {
      if (disabled) {
        return (
          /* eslint-disable */
          <span className={"LinkButton"} {...props} />
        )
      } else {
        return (
          /* eslint-disable */
          <a className={"LinkButton"} href="javascript:" onClick={onClick} {...props} />
        )
      }
    } else {
      // 添加 search
      if (to) {
        let { search } = to
        if (search && !_.isEmpty(search.trim())) {
          to = _.defaults({ search: appendSearch(search, window.pageProps.additionalSearch) }, to)
        }
      }

      return (
        <Link className={"LinkButton"} to={to}>
          {this.props.children}
        </Link>
      )
    }
  }
}

export default LinkButton
